import { render, staticRenderFns } from "./PermissionsStagesForm.vue?vue&type=template&id=ea4330fe&scoped=true&"
import script from "./PermissionsStagesForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsStagesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4330fe",
  null
  
)

export default component.exports